<template>
  <div class="d-flex-column justify-start align-start gap-8">
    <div class="d-flex-row justify-start gap-5">
      <label for="" class="t-light regular-l font-family-2">{{
        $t("missed.server")
      }}</label>
      <ItemTooltip :text="$t('new.select_server')" />
    </div>

    <div
      class="d-flex-row justify-start height-max-content width-max-content gap-0 b-radius-8 server_container"
    >
      <div
        class="game_server_button d-flex-row"
        :key="server.id"
        v-for="server in servers"
        role="button"
        :class="[
          selectedServers?.includes(server.id) && 'active',
          `server_lengt-${selectedServers.length}`,
        ]"
        @click="$emit('selectServer', server.id)"
      >
        <div class="d-flex-row width-max-content justify-start">
          <img
            :src="`/images/servers/${server?.title?.toLowerCase()}.webp`"
            class="server_icon"
            alt="server_icon"
            height="20"
            width="20"
          />
        </div>
        <label class="t-white medium-l font-family-2 f-w-500" v-if="showTitle">{{
          server?.title
        }}</label>
      </div>
    </div>
  </div>
</template>

<script setup>
import ItemTooltip from "../calculators/fc-25/pickers/ItemTooltip.vue";
const gameStore = useGameStore();
const emit = defineEmits(["selectServer"]);
const props = defineProps({
  selectedServers: {
    default: [],
  },
  showTitle: {
    default: true,
  },
});

const servers = ref([
  {
    id: 1,
    title: "Europe",
  },
  {
    id: 2,
    title: "USA",
  },
]);
</script>

<style lang="scss">
.server_container {
  padding: 2px;
  background-color: var(--bg-medium);
  .game_server_button {
    height: 36px;
    min-width: 100px;
    cursor: pointer;
    transition: all 0.2s ease;
    background-color: transparent;
    border: 1px solid transparent;

    &.server_lengt-2 {
      &:first-child {
        border-radius: 6px 0 0px 6px;
        border-right: 1px solid transparent;
      }
      &:last-child {
        border-radius: 0 6px 6px 0;
      }
    }
    &.server_lengt-1 {
      border-radius: 6px;
    }
    & > * {
      cursor: pointer;
    }
    .server_icon {
      width: 20px;
      height: auto;
      max-width: 20px;
      max-height: 20px;
      object-fit: cover;
      object-position: center;
      border-radius: 50%;
    }
    &:hover {
      background-color: var(--dark-blue);
    }
    &.active {
      background-color: var(--dark-blue);
      border: 1px solid var(--blue);
    }
  }
}
</style>
